import React, { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { PageRoute, replaceIdWithPath } from '../../types/page.types';
import { ActivityBar } from '../activity-bar/index';
import Header from '../header/index';

interface HeaderLayoutProps {
  children: ReactNode;
  className?: string;
}

const HeaderLayout: FC<HeaderLayoutProps> = ({ children, className }) => {
  const { pathname } = useLocation();

  return (
    <div className="flex h-full w-full flex-col gap-3 overflow-y-auto bg-gray-50 lg:pb-4 lg:pr-6">
      <Header />
      <div className="h-full w-full overflow-y-auto max-lg:px-4" id="mobile-scrollbar-target">
        <div
          className={twMerge(
            'flex h-fit w-full justify-between gap-4 overflow-y-auto bg-white px-3 py-4 shadow-sm max-lg:mb-4 max-lg:mt-[1px] max-lg:rounded-md max-xs:rounded-b-[6px] max-xs:rounded-t-[6px] max-xs:shadow-sm lg:h-full lg:rounded-t-[24px] lg:shadow-none',
            className,
          )}
          id="scrollbar-target"
        >
          {children}
          {replaceIdWithPath(pathname) !== PageRoute.COMPANY_SETUP &&
            replaceIdWithPath(pathname) !== PageRoute.BILLING &&
            replaceIdWithPath(pathname) !== PageRoute.ONBOARDING && <ActivityBar />}
        </div>
      </div>
    </div>
  );
};

export default HeaderLayout;
